import { objectsRHandler } from '@/utils/objectsRHandler';

import QuestionModel from '../list/question/index';
import QuestionTagModel from '../list/question/tag/index';

const API_PATH = 'event-poll-questions';
const API_PATH_TAGS = 'event-poll-question-tags';

export const QuestionManager = {
  objects: objectsRHandler(API_PATH, QuestionModel),
  tag: objectsRHandler(API_PATH_TAGS, QuestionTagModel),
};
